import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TArticleRateEventParams } from './_types';

export const articleRateEvent = (params: TArticleRateEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_RATE_CLICK,
    params,
  });
};
